'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_OPCIONES_MODIFICACION_CLIENTE,
    EDITANDO_CAMPO_CLIENTE,
    SELECCIONAR_VALOR_CAMPO_CLIENTE,
    ACTUALIZAR_ESTADO_NOVEDAD_CLIENTE,
    RECHAZA_ADMINISTRADORA_CLIENTE,
    DENIEGA_NOVEDAD_CLIENTE,
    ACEPTA_ADMINISTRADORA_CLIENTE,
    SAVE_NOVEDAD_CLIENTE,
    LIMPIAR_STORE_COMPONENTE_CLIENTE,
    GET_LOG_MODIFICACIONES_CLIENTE,
    ABRIR_MODAL_LOCALIZACION,
    EDITAR_CAMPO_LOCALIZACION,
    LIMPIAR_EDICIONES,
    SELECT_CHECK,
    ERROR_VALIDACION_LOCALIZACION,
    MODAL_CONFIRMADOR,
    ABRIR_MODAL_LOCALIZACION_MODIFICACION,
    ABRIR_MODAL_DOMICILIO_MODIFICACION,
    ACTUALIZAR_LOCALIZACION_CLIENTE,
    ABRIR_MODAL_LOCALIZACION_ELIMINAR,
    MODAL_ADVERTENCIA_DIRECCION_EXISTENTE,
    INTENTOS_AGOTADOS_GUARDADO_GLOBAL,
    LOADING_CLIENTE,
    ACEPTAR_MODAL_INFO,
    MOSTRAR_ERROR_VALIDACION,
    CAMPO_EN_PROCESO,
    SELECT_COMBO,
    GET_SCREEN_DATA_DOMICILIO,
    SELECT_CHECK_DOMICILIO,
    MODAL_ADVERTENCIA_DOMICILIO_EXISTENTE,
    ABRIR_MODAL_ADVERTENCIA_DOMICILIO_LEGAL
} from '../../Screens/Cliente/actions/Actions';
import { actualizarNovedadEstado } from '../../Screens/DatosCuenta/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    id: 0,
    SEXO_OPCIONES: [{ Id: "M", Descripcion: "Masculino" }, { Id: "F", Descripcion: "Femenino" }],
    tarjeta_prepaga: [{ Id: 1, Descripcion: 'Legal', Check: false }, { Id: 2, Descripcion: 'Correspondencia', Check: false }],
    tarjeta_credito: [{ Id: 1, Descripcion: 'Legal', Check: false }, { Id: 2, Descripcion: 'Correspondencia', Check: false }],
    novedades: [],
    novedadRechazadaId: [],
    novedadDenegadaId: [],
    checkProductoPrepaga: false,
    checkProductoCredito: false,
    telefonoEnEdicion: "",
    tiposCuentaDisponibles: null,
    tipolefonoEnEdicion: null,
    medioLocalizacionModificacion: [],
    arregloLocalizacionContacto: [],
    mediosLocalizacionEliminar: [],
    reintentosGuardado: 3,
    errorValidacionNovedad: {},
    calleEdicion:"",
    alturaEdicion:"",
    localidadEdicion:"",
    comentariosDomicilioEdicion:"",
    tiposProductoPermitidosModificacion: "AMBAS",
    validaCamposEdicion: {
        telefono: true,
        tipoTelefono: true,
        tipoProducto: true,
        validarRegistros: true,
        tipoDireccionElectronica: true,
        email: true,
        mailRepetidoTP: true,
        mailRepetidoTC: true,
        mailRepetidoSinCuenta: true,
        calle:true,
        altura:true,
        localidad:true,
        paisId:true,
        provinciaId:true,
        codigoPostalId:true,
        domicilioRepetido: true,
        checkDomicilioPrepago:true,
        checkDomicilio:true,
        domicilioLegalPrepaga:true,
        modificacionesDomicilio:true
    },
    domicilio: {
        TipoProducto: null,
        prepagoCheck: false,
        creditoCheck: false
    },
    domicilioComponentes: [],
    esModificacion: false
};


function cliente(state = initialState, action) {
    LogHelper.In(cliente.name, state, action);

    let result;
    switch (action.type) {
        case GET_OPCIONES_MODIFICACION_CLIENTE: {

            result = {
                ...state,
                cuenta: action.cuenta,
                cuentaCredito: action.cuentaCredito,
                NACIONALIDAD_OPCIONES: action.opcionesModificacion.Nacionalidad,
                ESTADO_CIVIL_OPCIONES: action.opcionesModificacion.EstadoCivil,
                OCUPACION_OPCIONES: action.opcionesModificacion.CondicionOcupacion,
                CATEGORIA_IVA_OPCIONES: action.opcionesModificacion.CategoriaIva,
                TIPO_DOCUMENTO_OPCIONES: action.opcionesModificacion.TipoDocumento,
                parametroGeneral: action.parametroGeneral[0],
                novedades: action.novedades,
                id: action.cliente.Id,
                Nombre: action.cliente.Nombre,
                Apellido: action.cliente.Apellido,
                DocumentoNumero: action.cliente.NumeroDocumento,
                DocumentoTipo: action.cliente.TipoDocumentoId,
                Cuit: action.cliente.Cuit,
                FechaNacimiento: action.cliente.FechaNacimiento,
                Sexo: action.cliente.Sexo,
                EstadoCivil: action.cliente.EstadoCivilId,
                Nacionalidad: action.cliente.NacionalidadId,
                CategoriaIva: action.cliente.CategoriaIvaId,
                Ocupacion: action.cliente.OcupacionId,
                tiposCuentaDisponibles: action.tiposCuentaDisponibles,
                arregloLocalizacionContacto: action.arregloLocalizacionContacto,
                contactosTotal: action.contactosTotal
            };
            break;
        }

        case GET_SCREEN_DATA_DOMICILIO: {
            
            result = {
                ...state,
                domiciliosTotal: action.domicilios,
                infoDomiciliosCuenta: action.infoDomiciliosCuenta
            }
            
            break;
        }

        case EDITANDO_CAMPO_CLIENTE: {
            result = {
                ...state,
                [action.campo]: action.valor,
                editandoCampo: !action.cierra ? action.campo : false,
                errorValidacionNovedad: {}
            };
            break;
        }
        case CAMPO_EN_PROCESO: {
            result = {
                ...state,
                campoNovedadesEnProceso: action.campo
            };
            break;
        }
        case MOSTRAR_ERROR_VALIDACION: {
            result = {
                ...state,
                errorValidacionNovedad: { [action.campo]: action.mensaje },
                loading_cliente: false
            };
            break;
        }

        case SELECT_COMBO: {
            const { valor, combo } = action;
            switch (combo) {
                case "Pais": {
                    result = {
                        ...state,
                        domicilio: {
                            paisId: valor
                        }
                    }
                    break;
                }
                case "Provincia": {
                    result = {
                        ...state,
                        domicilio: {
                            provinciaId: valor
                        }
                    }
                    break;
                }
                case "CodigoPostal": {
                    result = {
                        ...state,
                        domicilio: {
                            codigoPostalId: valor
                        }
                    }
                    break;
                }
            }
        }

        case SELECT_CHECK_DOMICILIO: {
            const { componente, value, params } = action;
            let array;
            switch (componente) {
                case "Prepaga":
                    let array = state.tarjeta_prepaga;
                    result = {
                        ...state,
                        tarjeta_prepaga: selectChecks(array, params, true),
                        domicilio: {
                            prepagoCheck: action.value
                        }
                    }
                    break;
                case "tarjeta_prepaga": {
                    array = state.tarjeta_prepaga;
                    result = {
                        ...state,
                        tarjeta_prepaga: selectChecks(array, params, false)
                    }
                }
                    break;
                case "Credito":
                    array = state.tarjeta_credito;
                    result = {
                        ...state,
                        tarjeta_credito: selectChecks(array, params, true),
                        domicilio: {
                            creditoCheck: action.value
                        }
                    }
                    break;
                case "tarjeta_credito": {
                    array = state.tarjeta_credito;
                    result = {
                        ...state,
                        tarjeta_credito: selectChecks(array, params, false)
                    }
                }
                    break;


            }


            break;
        }

        case SELECCIONAR_VALOR_CAMPO_CLIENTE: {
            if (action.valor != null) {
                result = {
                    ...state,
                    [action.codigo]: action.valor
                }
            } else {
                result = {
                    ...state
                };
            }
            break;
        }

        case SAVE_NOVEDAD_CLIENTE: {
            state.loading_cliente = false;
            result = {
                ...state,
                loading_cliente: false,
                novedades: action.data,
            }
            break;
        }

        case MODAL_ADVERTENCIA_DOMICILIO_EXISTENTE: {
            result = {
                ...state,
                modalAbierto: "DOMICILIO_EXISTENTE",
                domicilioPrevio: action.domicilioPrevio,
            }
            break;
        }

        case ABRIR_MODAL_ADVERTENCIA_DOMICILIO_LEGAL: {
            result = {
                ...state,
                modalAbierto: "ADVERTENCIA_DOMICILIO_LEGAL"
            }
            break;
        }

        case ACTUALIZAR_ESTADO_NOVEDAD_CLIENTE: {
            let campoNovedadCancelada = "deleteMe";

            if (state.novedadRechazadaId && state.novedadRechazadaId.length > 0) {// para el caso en que se rechazó el cambio, se muestra la novedad únicamente hasta que se sale de la pantalla
                action.novedades.map(nov => {
                    if (state.novedadRechazadaId.some(rec => rec == nov.Id) && nov.NovedadEstadoId == 6) {
                        nov.NovedadEstadoId = 21;
                    }
                })
            }

            if (state.novedadDenegadaId && state.novedadDenegadaId.length > 0) {// para el caso en que se rechazó el cambio, se muestra la novedad únicamente hasta que se sale de la pantalla
                action.novedades.map(nov => {
                    if (state.novedadDenegadaId.some(den => den == nov.Id) && nov.NovedadEstadoId == 3) {
                        nov.NovedadEstadoId = 22;
                    }
                })
            }

            action.novedades.map(nove => {
                if (nove.NovedadEstadoId > 20) {
                    if (action.novedades.some(n2 => n2.Codigo == nove.Codigo && n2.Id > nove.Id)) nove.NovedadEstadoId = nove.NovedadEstadoId == 21 ? 6 : 3;
                }
            })

            result = {
                ...state,
                loading_cliente: false,
                novedades: action.novedades,
                [campoNovedadCancelada]: action.novedadesCanceladas,
                campoNovedadesEnProceso: null
            }

            break;
        }

        case RECHAZA_ADMINISTRADORA_CLIENTE: {
            let rechazadasAux = JSON.parse(JSON.stringify(state.novedadRechazadaId));
            if (!rechazadasAux.some(rec => rec == action.novedadId)) rechazadasAux.push(action.novedadId);

            result = {
                ...state,
                novedadRechazadaId: rechazadasAux
            };
            break;
        }

        case DENIEGA_NOVEDAD_CLIENTE: {
            let denegadasAux = JSON.parse(JSON.stringify(state.novedadDenegadaId));
            if (!denegadasAux.some(den => den == action.novedadId)) denegadasAux.push(action.novedadId);

            result = {
                ...state,
                campoNovedadesEnProceso: null,
                novedadDenegadaId: denegadasAux
            };
            break;
        }

        case ACEPTA_ADMINISTRADORA_CLIENTE: {
            let novRechazada = JSON.parse(JSON.stringify(state.novedadRechazadaId));
            if (novRechazada.some(rec => rec == action.novedadId)) novRechazada = novRechazada.filter(rec => rec != action.novedadId);

            result = {
                ...state,
                loading_cliente: false,
                [action.campo]: action.valor,
                novedadRechazadaId: novRechazada,
                campoNovedadesEnProceso: null
            }
            break;
        }

        case LIMPIAR_STORE_COMPONENTE_CLIENTE: {
            if (action.campo) {
                result = {
                    ...state,
                    [action.campo]: null,
                    editandoCampo: false,
                    errorValidacionNovedad: {},
                    novedadRechazadaId: [],
                    novedadDenegadaId: []
                };
            } else {
                result = {
                    ...state,
                    editandoCampo: false,
                    novedadRechazadaId: [],
                    novedadDenegadaId: []
                };
            }
            break;
        }

        case GET_LOG_MODIFICACIONES_CLIENTE: {

            result = {
                ...state,
                modificacionesCliente: action.modificaciones,
                viendoModificacionesCampo: action.campoCodigo
            };
            break;
        }

        case ABRIR_MODAL_LOCALIZACION: {

            result = {
                ...state,
                modalAbierto: action.medio,
                tiposComunicacion: action.tiposComunicacion,
                infoCuentas: action.infoCuentas,
                emailCuentasActuales: action.emailCuentasActuales ? action.emailCuentasActuales : null,
                domicilioComponentes: action.opcionesModificacionDomicilio ? action.opcionesModificacionDomicilio : state.domicilioComponentes                 
            };
            break;
        }

        case MODAL_ADVERTENCIA_DIRECCION_EXISTENTE: {

            result = {
                ...state,
                modalAbierto: !action.esModificacion ? "DIRECCIONEXISTENTE" : "DIRECCIONEXISTENTE-MODIFICACION",
            };
            break;
        }

        case EDITAR_CAMPO_LOCALIZACION: {

            if (action.valida) {
                result = {
                    ...state,
                    [action.campoEnEdicion]: action.valor
                };
            } else {
                result = {
                    ...state
                };
            }
            break;
        }

        case LIMPIAR_EDICIONES: {
            result = {
                ...state,
                telefonoEnEdicion: "",
                tipoTelefonoEnEdicion: null,
                tipoDireccionElectronica: null,
                emailEnEdicion: null,
                infoCuentas: null,
                checkProductoPrepaga: false,
                checkProductoCredito: false,
                medioLocalizacionModificacion: [],
                mediosLocalizacionEliminar: [],
                emailCuentasActuales: null,
                calleEdicion:"",
                alturaEdicion:"",
                pisoEdicion:"",
                deptoEdicion:"",
                localidadEdicion:"",
                comentariosDomicilioEdicion:"",
                paisId:null,
                provinciaId:null,
                codigoPostalId:null,
                loading_cliente: false,
                esModificacion:false,
                tiposProductoPermitidosModificacion: "AMBAS",
                domicilioModificacion:null,
                tarjeta_credito:[{Id: 1, Descripcion: "Legal", Check: false},{Id: 2, Descripcion: "Correspondencia", Check: false}],
                tarjeta_prepaga:[{Id: 1, Descripcion: "Legal", Check: false},{Id: 2, Descripcion: "Correspondencia", Check: false}],
                domicilio:{
                    creditoCheck: false,
                    prepagoCheck: false
                },
                validaCamposEdicion: {
                    telefono: true,
                    tipoTelefono: true,
                    tipoProducto: true,
                    validarRegistros: true,
                    tipoDireccionElectronica: true,
                    email: true,
                    mailRepetidoTP: true,
                    mailRepetidoTC: true,
                    mailRepetidoSinCuenta: true,
                    calle:true,
                    altura:true,
                    localidad:true,
                    paisId:true,
                    provinciaId:true,
                    codigoPostalId:true,
                    domicilioRepetido: true,
                    checkDomicilioPrepago: true,
                    checkDomicilio: true,
                    domicilioLegalPrepaga: true,
                    modificacionesDomicilio:true
                }
            };

            break;
        }

        case SELECT_CHECK: {

            result = {
                ...state,
                checkProductoPrepaga: action.checkPrepaga,
                checkProductoCredito: action.checkCredito
            };

            break;
        }

        case ERROR_VALIDACION_LOCALIZACION: {
            debugger
            result = {
                ...state,
                validaCamposEdicion: action.validaCamposEdicion
            };

            break;
        }

        case MODAL_CONFIRMADOR: {
            if (action.accion == "abrir") {
                result = {
                    ...state,
                    modalAbierto: "CONFIRMADOR",
                    invocadorConfirmador: action.invocador
                };
            } else if (action.accion == "cancelar") {
                result = {
                    ...state,
                    modalAbierto: action.invocador,
                    invocadorConfirmador: null
                };
            } else if (action.accion == "confirmar") {
                result = {
                    ...state,
                    modalAbierto: null,
                    invocadorConfirmador: null
                };
            }
            break;
        }

        case ABRIR_MODAL_DOMICILIO_MODIFICACION: {
            let medio = action.medio;

            result = {
                ...state,
                domicilioComponentes: action.domicilioComponentes ? action.domicilioComponentes : state.domicilioComponentes,
                esModificacion: true,
                modalAbierto: "MODIFICACION-1",
                domicilioModificacion:medio,
                calleEdicion:medio.Calle,
                alturaEdicion:medio.Numero,
                pisoEdicion:medio.Piso,
                deptoEdicion:medio.Departamento,
                localidadEdicion:medio.Localidad,
                comentariosDomicilioEdicion:medio.Comentario,
                paisId:medio.PaisId,
                provinciaId:medio.ProvinciaId,
                codigoPostalId: medio.CodigoPostalId,
                tarjeta_credito:[{Id: 1, Descripcion: "Legal", Check: action.checks.credito.legal},{Id: 2, Descripcion: "Correspondencia", Check: action.checks.credito.correspondencia}],
                tarjeta_prepaga:[{Id: 1, Descripcion: "Legal", Check: action.checks.prepaga.legal},{Id: 2, Descripcion: "Correspondencia", Check: action.checks.prepaga.correspondencia}],
                domicilio:{
                    creditoCheck: action.checks.credito.legal || action.checks.credito.correspondencia,
                    prepagoCheck: action.checks.prepaga.legal || action.checks.prepaga.correspondencia
                }
            }
            break;
        }

        case ABRIR_MODAL_LOCALIZACION_MODIFICACION: {
            let esElectronico = ![1,3,4].some(m=>m==action.medio.TipoComunicacionId);
            
            result = {
                ...state,
                modalAbierto: "MODIFICACION-" + (!esElectronico ? action.medio.TipoComunicacionId : 2),//TODOS LOS MEDIOS ELECTRÓNICOS USAN EL MODAL DE MODIFICACIÓN DEL MAIL
                tiposComunicacion: action.tiposComunicacion,
                checkProductoPrepaga: action.medio.TipoProducto == "Tarjeta Prepaga" || action.medio.TipoProducto == "ambas",
                checkProductoCredito: action.medio.TipoProducto == "Tarjeta Crédito" || action.medio.TipoProducto == "ambas",
                telefonoEnEdicion: !esElectronico ? action.medio.Contacto : null,
                tipoTelefonoEnEdicion: !esElectronico ? action.medio.TipoComunicacionId : null,
                emailEnEdicion: esElectronico ? action.medio.Contacto : null,
                medioLocalizacionModificacion: action.arregloContactosAModificar,
                tiposProductoPermitidosModificacion: action.tiposProductoPermitidosModificacion,
                tipoDireccionElectronica: esElectronico ? action.medio.TipoComunicacionId : null,
                emailCuentasActuales: action.emailCuentasActuales ? action.emailCuentasActuales : null
            };
            break;
        }

        case ABRIR_MODAL_LOCALIZACION_ELIMINAR: {
            
            result = {
                ...state,
                modalAbierto: "ELIMINAR",
                invocadorConfirmador: "ELIMINAR",
                mediosLocalizacionEliminar: action.arregloContactosAEliminar
            };
            break;
        }

        case ACTUALIZAR_LOCALIZACION_CLIENTE: {

            result = {
                ...state,
                arregloLocalizacionContacto: action.arregloLocalizacionContacto,
                contactosTotal: action.contactosTotal
            };
            break;
        }

        case LOADING_CLIENTE: {

            result = {
                ...state,
                loading_cliente: true,
                modalAbierto: null
            };
            break;
        }

        case INTENTOS_AGOTADOS_GUARDADO_GLOBAL: {

            result = {
                ...state,
                modalAbierto: "ERROR-GUARDADO-GLOBAL"
            };
            break;
        }

        case ACEPTAR_MODAL_INFO: {

            result = {
                ...state,
                modalAbierto: null
            };
            break;
        }

        default:
            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(cliente.name, result);
    return result;
}

/**
 * 
 * @param {any} array
 * @param {any} id
 * @param {any} value
 */
function selectChecks(array, id, isDelete) {
    LogHelper.In(selectChecks.name, array, id, isDelete);

    return array.map(item => {
        if (!isDelete) {
            if (item.Id == id) {
                item.Check = !item.Check;

                // if (edicion) {
                //     item.Cambio = !item.Cambio;
                // }
            }
        } else {
            item.Check = false;
        }

        return item;
    });
}


export default cliente;